export default "__VITE_ASSET__8NDAoubr__"